module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Paul Was Not a Christian")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "paulwasnotachristian.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }), _c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }), _c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_ack01#ack01"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "fm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_fm01#fm01"
    }
  }, [_vm._v("Note to the Reader")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "fm_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName2"
  }, [_c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_fm02#fm02"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_ch01#ch01"
    }
  }, [_vm._v("1.")]), _vm._v(" Was Paul Really Jewish?")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_ch02#ch02"
    }
  }, [_vm._v("2.")]), _vm._v(" Paul the Problem")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/paulwasnotachristian_ch03#ch03"
    }
  }, [_vm._v("3.")]), _vm._v(" How Paul Became a Christian")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")]), _vm._v(" Reading Paul as a Jew—Almost")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")]), _vm._v(" Paul’s Jewish Inheritance")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")]), _vm._v(" Who Is and Who Isn’t a Jew?")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")]), _vm._v(" The Flexible Pharisees")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")]), _vm._v(" Paul the (Ex?)-Pharisee")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")]), _vm._v(" A Typical Jew")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")]), _vm._v(" A Radical Jewish Monotheist")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")]), _vm._v(" On a Mission from God")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")]), _vm._v(" “On the Contrary, We Uphold the Law!”")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")]), _vm._v(" Justification Through Jesus Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")]), _vm._v(" It’s the End of the World as We Know It")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "bm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "not_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_not01#not01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "bm_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_bm02#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ind_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ind01#ind01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searchable Terms")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_ata01#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cre_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_cre01#cre01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_cop01#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('span', {
    attrs: {
      "href": "#/paulwasnotachristian_atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d7aaaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paulwasnotachristian_toc.vue
// module id = 66
// module chunks = 0